<template>
  <v-tabs dark dense grow centered v-model="selectedNavLinkAux">
    <v-tab
      v-for="(name, index) in linkList"
      :value="index"
      :key="name"
      v-on:click="onClientSelect(index)"
      v-bind:class="[
        selectedNavLinkAux === index ? 'active' : '',
        isLight ? 'lightTab' : '',
        isDark ? 'darkTab' : ''
      ]"
      >{{ name }}</v-tab
    >
  </v-tabs>
</template>

<script>
export default {
  name: "NavbarCustomComponent",
  props: {
    selectedNavLink: { required: true },
    isLight: { required: false, type: Boolean, default: false },
    isDark: { required: false, type: Boolean, default: false },
    linkList: { required: true }
  },
  data() {
    return {
      selectedNavLinkAux: 0
    };
  },
  mounted() {
    this.selectedNavLinkAux = this.selectedNavLink;
  },
  watch: {
    selectedNavLink(val) {
      this.selectedNavLinkAux = val;
    }
  },
  methods: {
    onClientSelect(idx) {
      this.$emit("eventOnClientSelect", idx);
    }
  }
};
</script>
